import {orderBy} from "@progress/kendo-data-query";
import {Grid, GridColumn} from "@progress/kendo-react-grid";
import {
    assignQtyKey,
    descriptionKey,
    endDateKey,
    licenseTypeKey,
    mainMessages,
    productNumberKey,
    qtyKey,
    startDateKey
} from "../../../assets/text/MultilingualText";
import {DateCell, NoWrapCell, TextAlignMiddleCell} from "../../common/Grid";
import React, {useContext} from "react";
import UserContext from "../../common/UserContext";
import {AssignedProductContext, GeneralContext, SelectedProductContext} from "../FSARequestLicenseContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {DeleteCell} from "./DeleteCell";
import {AssignHostQtyCell} from "./AssignHostQtyCell";

export const AssignHostGrid = (props) => {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        uniqueID,
        parentUniqueID,
        productNumKey,
        licenseStartDateKey,
        licenseEndDateKey,
    } = useContext(GeneralContext);

    const {
        selectedProducts,
    } = useContext(SelectedProductContext);

    const {
        assignedProducts,
        setAssignedProducts,
        unsavedAssignedChanges,
        setUnsavedAssignedChanges,
    } = useContext(AssignedProductContext);

    const {
        currentHost,
        setShowGenericError
    } = props

    const localization = useLocalization();

    const onItemChange = (e) => {
        const newAssignedProducts = assignedProducts.map(host => {
            if(host.transaction_id === currentHost.transaction_id) {
                host.products = host.products.map(product => {
                    if (product[uniqueID] === e.dataItem[uniqueID]) {
                        let newAssignedQty = parseInt(e.value)

                        if (isNaN(newAssignedQty) || newAssignedQty <= 0) {
                            newAssignedQty = e.dataItem.quantity || 0;
                        }

                        // get all total assigned quantities of a product across all hosts
                        // cannot use select product unassigned quantity because changes have not been saved
                        let maxQty = selectedProducts.find(p => p[uniqueID] === e.dataItem[parentUniqueID])?.quantity || 0
                        let totalQty = newAssignedQty;
                        assignedProducts.forEach(host => {
                            host.products.forEach(p => {
                                if (e.dataItem[uniqueID] !== p[uniqueID] && e.dataItem[parentUniqueID] === p[parentUniqueID]) {
                                    totalQty += parseInt(p.assign_quantity) || 0;
                                }
                            })
                        });

                        // assign qty cannot be greater than total qty of product, set to most quantity
                        if (totalQty > maxQty) {
                            newAssignedQty = maxQty + newAssignedQty - totalQty;
                        }
                        product[e.field] = newAssignedQty;

                        // update unsaved changes
                        unsavedAssignedChanges.add(product[uniqueID])
                        setUnsavedAssignedChanges(unsavedAssignedChanges)
                    }
                    return product
                })
            }
            return host;
        })
        setAssignedProducts(newAssignedProducts)
    };

    return (
        <Grid
            className={"fsa-assign-products-grid"}
            data={orderBy(currentHost.products, [{
                field: "ea_alloc_id",
                dir: "desc"
            }])}
            scrollable={'none'}
            sortable={false}
            onItemChange={onItemChange}
        >
            <GridColumn
                field={null}
                title={""}
                cell={(props) =>
                    <DeleteCell
                        setShowGenericError={setShowGenericError}
                        {...props}
                    />
            }
                sortable={false}
            />
            <GridColumn
                field={productNumKey}
                title={localization.toLanguageString(productNumberKey, mainMessages[siteLanguageDefault][productNumberKey])}
                cell={NoWrapCell}
            />

            <GridColumn
                field="description"
                title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
            />

            <GridColumn
                field="quantity"
                title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                cell={TextAlignMiddleCell}
            />

            <GridColumn
                field="assign_quantity"
                title={localization.toLanguageString(assignQtyKey, mainMessages[siteLanguageDefault][assignQtyKey])}
                filter={'numeric'}
                cell={AssignHostQtyCell}
                sortable={false}
            />

            <GridColumn
                field="license_type_text"
                title={localization.toLanguageString(licenseTypeKey, mainMessages[siteLanguageDefault][licenseTypeKey])}
                cell={NoWrapCell}
            />

            <GridColumn
                field={licenseStartDateKey}
                title={localization.toLanguageString(startDateKey, mainMessages[siteLanguageDefault][startDateKey])}
                filter={'date'}
                cell={DateCell}
            />

            <GridColumn
                field={licenseEndDateKey}
                title={localization.toLanguageString(endDateKey, mainMessages[siteLanguageDefault][endDateKey])}
                filter={'date'}
                cell={DateCell}
            />
        </Grid>
    )
}